import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

export default function ServicesSection() {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({
      duration: 800,
      once: false, // 👈 ensures animation happens every time element enters viewport
      easing: "ease-in-out",
    });
  }, []);

  const services = [
    {
      id: "servicenow",
      title: "ServiceNow",
      desc: "Empower your digital transformation journey with our ServiceNow specialists.",
      logoUrl: "../service.png",
      link: "/contact",
    },
    {
      id: "apps-development",
      title: "Apps Development",
      desc: "Custom mobile solutions that deliver tangible business results.",
      logoUrl: "../app.png",
      link: "/services",
    },
    {
      id: "web-development",
      title: "Custom Web Application",
      desc: "Create user-friendly, fast, and secure websites.",
      logoUrl: "../web.png",
      link: "/services",
    },
    {
      id: "ecommerce",
      title: "E-Commerce",
      desc: "We build secure, scalable, and user-friendly E-Commerce platforms.",
      logoUrl: "../commerce.png",
      link: "/services",
    },
    {
      id: "salesforce",
      title: "Salesforce",
      desc: "Streamline sales, marketing, and customer support with custom Salesforce solutions.",
      logoUrl: "../force.png",
      link: "/services",
    },
    {
      id: "staff-augmentation",
      title: "Staff Augmentation",
      desc: "Get skilled IT professionals on-demand to scale your team efficiently.",
      logoUrl: "../staffa.png",
      link: "/services",
    },
  ];

  return (
    <section className="min-h-screen flex flex-col justify-center bg-gradient-to-b from-gray-100 to-gray-50 overflow-hidden">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        {/* Header */}
        <div className="text-center mb-10">
          <p
            className="text-xs uppercase tracking-widest text-[#df2313] mb-1"
            style={{ marginTop: "6rem" }}
          >
            Our Services
          </p>
          <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-3">
            Modern Solutions for a Digital Era
          </h2>
          <p className="text-gray-600 max-w-xl mx-auto text-sm">
            We deliver innovative services that combine technology and creativity to
            boost your business in the digital world.
          </p>
        </div>

        {/* Service Cards */}
        <div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8"
          style={{ marginBottom: "3rem" }}
        >
          {services.map((service, index) => (
            <div
              key={service.id}
              className="relative bg-white/80 border border-gray-200 p-6 md:p-8 rounded-3xl shadow-md hover:shadow-xl hover:scale-[1.03] transition-all duration-300 flex flex-col items-center text-center group overflow-hidden"
            >
              {/* Soft background glow */}
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                <div className="absolute -top-10 -right-10 w-28 h-28 bg-blue-200 rounded-full blur-3xl"></div>
                <div className="absolute bottom-0 left-0 w-20 h-20 bg-blue-100 rounded-full blur-2xl"></div>
              </div>

              {/* Logo */}
              <div
                data-aos="fade-up"
                data-aos-offset="120"
                className="relative w-24 h-24 mb-5 flex items-center justify-center"
              >
                <div className="absolute inset-0 bg-blue-200/40 rounded-full blur-2xl group-hover:blur-3xl transition-all duration-500"></div>
                <img
                  src={service.logoUrl}
                  alt={service.title}
                  className="w-16 h-16 md:w-20 md:h-20 object-contain relative z-10"
                />
              </div>

              {/* Title */}
              <h3
                data-aos="fade-up"
                data-aos-delay="100"
                className="text-lg font-semibold text-gray-900 mb-2"
              >
                {service.title}
              </h3>

              {/* Description */}
              <p
                data-aos="fade-up"
                data-aos-delay="200"
                className="text-gray-600 text-sm mb-5 leading-relaxed"
              >
                {service.desc}
              </p>

              {/* Button */}
              <button
                data-aos="fade-up"
                data-aos-delay="300"
                onClick={() => navigate(service.link)}
                className="inline-flex items-center justify-center px-5 py-2 text-sm text-white font-medium rounded-full shadow-md bg-gradient-to-r from-[#df2313] to-[#df2313] hover:from-black hover:to-black transition-all duration-300"
              >
                Hire Now
                <svg
                  className="w-4 h-4 ml-2 transition-transform duration-300 group-hover:translate-x-1"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* Floating Animation */}
      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-6px); }
        }
        .animate-float {
          animation: float 3.5s ease-in-out infinite;
        }
      `}</style>
    </section>
  );
}
